






























import {Component, Mixins} from 'vue-mixin-decorator';
import {getModule} from 'vuex-module-decorators';
import {Prop} from 'vue-property-decorator';

import {Notify} from '@/utils/Notify';

import {Connection} from '@/model/network/connection/Connection';

import NetworkConnectionsStore from '@/store/network/NetworkConnections.store';

import {BaseComponent} from '@/mixins/BaseComponent';
import PropertyDisplayer from '@/components/Utils/PropertyDisplayer.vue';

@Component({
  components: {PropertyDisplayer},
})
export default class NetworkConnectionSummary extends Mixins<BaseComponent>(BaseComponent) {
  @Prop()
  private connectionId!: string;

  private connectionsStore: NetworkConnectionsStore = getModule(NetworkConnectionsStore, this.$store);

  private async mounted() {
    try {
      await this.connectionsStore.fetchConnection(this.connectionId);
    } catch (error) {
      Notify.Error(this.logger, `Could not get connection '${this.connectionId}' info`, error);
    }
  }

  get connection(): Connection | null {
    return this.connectionsStore.Connections?.find((c) => c.Id === this.connectionId) ?? null;
  }
}
